/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, ProjectEditDTO } from '../fastAPI.schemas'

/**
 * @summary Get Project Edits
 */
export const getProjectEdits = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ProjectEditDTO[]>({
    url: `/projects/${projectGuid}/edits`,
    method: 'GET',
    signal,
  })
}

export const getGetProjectEditsQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/edits`] as const
}

export const getGetProjectEditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectEdits>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectEdits>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetProjectEditsQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectEdits>>> = ({ signal }) =>
    getProjectEdits(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectEdits>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProjectEditsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectEdits>>>
export type GetProjectEditsQueryError = HTTPValidationError

/**
 * @summary Get Project Edits
 */

export function useGetProjectEdits<
  TData = Awaited<ReturnType<typeof getProjectEdits>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getProjectEdits>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectEditsQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
